export default __webpack_public_path__ + "static/media/filled_person.868e2c00.svg";